import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../Hooks/Hooks';
import { RootState } from '../../Redux/Store';
import { setShowBanner } from '../../Redux/Reducers/ContentOrConfigSlice';
import cancel from '../../../../src/assets/icon/cancel.svg';
import '../../Style/Responsive.scss';
import './AlertBanner.scss';

const AlertBanner = () => {
  const dispatch = useDispatch();
  const { contentStackData } = useAppSelector((state: RootState) => state.ContentOrConfig);

  const content = contentStackData?.fpoo_alert_banner ? contentStackData?.fpoo_alert_banner[0] : {};

  return (
    <div className={`Alert_Banner_Container`}>
      <div className='AlertBanner_Content_Image'>
        <img src={content?.icon?.url} alt="" className="AlertBanner_Content_Image" />
      </div>
      <div>
        <p>{content?.heading}</p>
      </div>
      <div
        onClick={() => {
          dispatch(setShowBanner(false));
        }}
        className="Banner_Cancel_Icon"
      >
        <img src={cancel} alt="Cancel icon" height={'10px'} />
      </div>
    </div>
  );
};

export default AlertBanner;
